(() => {
  const WRAP_SELECTOR = '[data-bull-qty-discounts]';

  const formatMoney = (cents, moneyFormat) => {
    try {
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    } catch (e) {}
    const clp = Math.round(cents / 100);
    return '$' + clp.toLocaleString('es-CL');
  };

  const discountForQty = (q) => (q >= 3 ? 15 : q === 2 ? 10 : 0);
  const tierFromQty = (q) => (q >= 3 ? '3' : q === 2 ? '2' : '1');
  const qtyFromTier = (tier) => (tier === '3' ? 3 : tier === '2' ? 2 : 1);

  function initWrap(wrap) {
    if (!wrap || wrap.dataset.bullInited === '1') return;
    wrap.dataset.bullInited = '1';

    const statusEl = wrap.querySelector('[data-bull-status]');
    const setStatus = (txt) => { if (statusEl) statusEl.textContent = `status: ${txt}`; };

    const sectionId = wrap.getAttribute('data-bull-section-id') || '';
    const moneyFormat = wrap.getAttribute('data-money-format') || '';
    const totalEl = wrap.querySelector('[data-bull-total]');
    const cards = Array.from(wrap.querySelectorAll('.bull-qty-card'));

    // 1) Encontrar el contenedor del producto correcto
    const productRoot =
      document.getElementById(`MainProduct-${sectionId}`) ||
      wrap.closest('product-info') ||
      document;

    // 2) Encontrar el form REAL de add-to-cart
    let form =
      document.getElementById(`product-form-${sectionId}`) ||
      productRoot.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) {
      setStatus('NO encuentro form /cart/add');
      return;
    }

    // 3) Quantity input (en Sense suele existir #Quantity-{{section.id}})
    const qtyInput =
      document.querySelector(`#Quantity-${sectionId}`) ||
      form.querySelector('input.quantity__input[name="quantity"]') ||
      form.querySelector('input[name="quantity"]');

    if (!qtyInput) {
      setStatus('NO encuentro input quantity');
      return;
    }

    // 4) Variant id input (Sense: input[name="id"])
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      setStatus('NO encuentro input variant id (name="id")');
      return;
    }

    const addBtn = form.querySelector('button[type="submit"], input[type="submit"]');

    let productJson = null;
    const loadProductJson = () => {
      if (productJson) return productJson;

      // Sense: suele haber JSON en la sección / shopify-section cercana
      const root = productRoot.closest('.shopify-section') || productRoot.closest('section') || document;
      const scripts = root.querySelectorAll('script[type="application/json"]');
      for (const s of scripts) {
        try {
          const obj = JSON.parse(s.textContent);
          if (obj && Array.isArray(obj.variants)) {
            productJson = obj;
            return productJson;
          }
        } catch (e) {}
      }
      return null;
    };

    const getQty = () => {
      const q = parseInt(qtyInput.value || '1', 10);
      return Math.max(Number.isFinite(q) ? q : 1, 1);
    };

    const setQty = (q) => {
      qtyInput.value = String(q);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const getVariantPriceCents = () => {
      const pj = loadProductJson();
      const vid = parseInt(idInput.value || '0', 10);
      if (pj && vid) {
        const v = pj.variants.find(x => parseInt(x.id, 10) === vid);
        if (v && v.price != null) return parseInt(v.price, 10);
      }
      return 0;
    };

    const setActiveByQty = (q) => {
      const tier = tierFromQty(q);
      cards.forEach((c) => {
        const active = c.getAttribute('data-tier') === tier;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const updateTotal = () => {
      const q = getQty();
      setActiveByQty(q);

      const unit = getVariantPriceCents();
      if (!unit) {
        setStatus('OK, pero no pude leer precio de la variante');
        if (totalEl) totalEl.textContent = '—';
        return;
      }

      const disc = discountForQty(q);
      const total = Math.round(unit * q * (1 - disc / 100));

      if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
      setStatus(`OK (qty=${q}, desc=${disc}%, unit=${unit})`);

      if (addBtn && addBtn.tagName && addBtn.tagName.toLowerCase() === 'button') {
        if (!addBtn.dataset.bullOriginalText) addBtn.dataset.bullOriginalText = addBtn.textContent.trim();
        addBtn.textContent = `${addBtn.dataset.bullOriginalText} — ${formatMoney(total, moneyFormat)}`;
      }
    };

    // Click tarjetas => setQty
    wrap.addEventListener('click', (e) => {
      const card = e.target.closest('.bull-qty-card');
      if (!card) return;
      const tier = card.getAttribute('data-tier');
      setQty(qtyFromTier(tier));
      updateTotal();
    });

    // Cambios qty (manual + botones)
    qtyInput.addEventListener('input', updateTotal);
    qtyInput.addEventListener('change', updateTotal);

    const qtyWrapper = qtyInput.closest('quantity-input');
    if (qtyWrapper) {
      qtyWrapper.addEventListener('click', () => setTimeout(updateTotal, 0), { passive: true });
    }

    // Cambios variante
    idInput.addEventListener('change', () => setTimeout(updateTotal, 0));
    form.addEventListener('change', () => setTimeout(updateTotal, 0));

    setStatus('JS activo, inicializado');
    updateTotal();
  }

  const initAll = () => document.querySelectorAll(WRAP_SELECTOR).forEach(initWrap);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
